import { FlashcardsBaseStatsDto } from 'api/generated';
import LegendItem from 'pages/Performance/components/LegendItem';
import React, { FC } from 'react';
import styled from 'styled-components';
import { respondToWidth } from 'styles/general/respondTo';
import { StatisticColumnType } from 'types';

type LegendProps = {
  data: FlashcardsBaseStatsDto | null;
};

const Legend: FC<LegendProps> = ({ data }) => {
  return (
    <Container>
      <LegendItem name={StatisticColumnType.YES} percent={data?.yes.percent || 0} amount={data?.yes.count || 0} />
      <LegendItem name={StatisticColumnType.KINDA} percent={data?.kinda.percent || 0} amount={data?.kinda.count || 0} />
      <LegendItem name={StatisticColumnType.NO} percent={data?.no.percent || 0} amount={data?.no.count || 0} />
      <LegendItem
        name={StatisticColumnType.UNUSED}
        percent={data?.unanswered.percent || 0}
        amount={data?.unanswered.count || 0}
      />
    </Container>
  );
};

export default Legend;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 60px;
  position: sticky;

  ${respondToWidth.lg`
    gap:20px;
  `}

  ${respondToWidth.ls`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  `}

  ${respondToWidth.sm`
    display:flex;
    flex-direction:column;
    align-items: start;
    gap:20px;
  `}
`;
